import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Loader } from '../../../components/Loader';
import { selectWork } from '../../Api/selectors';
import { fetchInvoice } from '../actions';
import { REQUEST_INVOICE } from '../constants';
import { selectInvoice, selectInvoiceById } from '../selectors';
import { formatCurrency } from '../../../utils/string';

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class WithInvoiceComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (!this.props.invoice?.id) {
      this.props.fetch();
    } else {
    }
  }

  render() {
    if (!this.props.invoice?.id && this.props.loading) return <Loader small />;
    if (!this.props.invoice) return null;
    if (this.props.propertyName) {
      return <span>{this.props.invoice?.[this.props.propertyName]}</span>;
    }
    if (this.props.propertyNamePrice) {
      return <span>{formatCurrency(this.props.invoice?.[this.props.propertyNamePrice])}</span>;
    }
    return this.props.children;
  }
}

WithInvoiceComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoiceById(ownProps.invoiceId),
    loading: selectWork([`${REQUEST_INVOICE}-${ownProps.invoiceId}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      if (!ownProps.invoiceId) return;
      dispatch(fetchInvoice(ownProps.invoiceId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WithInvoice = compose(withConnect, withRouter)(WithInvoiceComp);
